import Vue from 'vue'
import VInput from '@/components/common/Input/v-input.js'
import VSelect from '@/components/common/v-select/index.jsx'
import Tab from '@/components/common/v-tab'
import Ptable from '@/components/common/pagination-table/table.js'
import VCardList from '@/components/common/v-card-list'
// import Vbutton from '@/components/common/v-button'
import VModal from '@/components/common/dialog'
import hevueImgPreview from 'hevue-img-preview'

import {
  ConfigProvider,
  Layout,
  Input,
  InputNumber,
  Button,
  Switch,
  Radio,
  Checkbox,
  Select,
  Card,
  Form,
  Row,
  Col,
  Modal,
  Table,
  Tabs,
  Icon,
  Badge,
  Popover,
  Dropdown,
  List,
  Avatar,
  Breadcrumb,
  Steps,
  Spin,
  Menu,
  Drawer,
  Tooltip,
  Alert,
  Tag,
  Divider,
  DatePicker,
  TimePicker,
  Upload,
  Progress,
  Skeleton,
  Popconfirm,
  PageHeader,
  Result,
  Statistic,
  Descriptions,
  Space,
  message,
  notification,
  FormModel,
  TreeSelect,
  Affix,
  Cascader
} from 'ant-design-vue'

Vue.use(ConfigProvider)
Vue.use(Cascader)
Vue.use(Layout)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Button)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Card)
Vue.use(Form)
Vue.use(Row)
Vue.use(Col)
Vue.use(Modal)
Vue.use(Table)
Vue.use(Tabs)
Vue.use(Icon)
Vue.use(Badge)
Vue.use(Popover)
Vue.use(Dropdown)
Vue.use(List)
Vue.use(Avatar)
Vue.use(Breadcrumb)
Vue.use(Steps)
Vue.use(Spin)
Vue.use(Menu)
Vue.use(Drawer)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(Tag)
Vue.use(Divider)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(Popconfirm)
Vue.use(PageHeader)
Vue.use(Result)
Vue.use(Statistic)
Vue.use(Descriptions)
Vue.use(Space)
Vue.use(FormModel)
Vue.use(Form.Item)
Vue.use(TreeSelect)
Vue.use(Affix)

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$message = message
Vue.prototype.$notification = notification
Vue.prototype.$info = Modal.info
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.prototype.$warning = Modal.warning

Vue.use(hevueImgPreview)
Vue.component('v-tab', Tab)
Vue.component('p-table', Ptable)
Vue.component('a-input', VInput)
Vue.component('a-select', VSelect)
Vue.component('v-card-list', VCardList)
Vue.component('a-modal', VModal)
// Vue.component('a-button', Vbutton)
